// Arabic strings for the messaging, correlation and reports stream — DEVELOPMENT DRAFT by Claude
// (PD-011); unreviewed until decision H-10.
import type { enMsg } from './en-msg.ts';
import type { Message } from './types.ts';

export const arMsg: { readonly [K in keyof typeof enMsg]: Message } = {
  // ------------------------------------------------------------ PB-15-13 correlation view
  'msg.corr.operations': 'عمليات المزوّدين والمحوّلات',
  'msg.corr.verifications': 'معاملات التحقق من الهوية',
  'msg.corr.webhooks': 'تسليمات Webhook',
  'msg.corr.inbound': 'أحداث واردة من المزوّدين',
  'msg.corr.receipts': 'إيصالات لاحقة لهذه السجلات',
  'msg.corr.receiptsHint': 'استدعاءات المزوّدين وقرارات المطابقة المسجّلة تحت مرجع ربط آخر.',
  'msg.corr.reconcile': 'مطابقة',
  'msg.corr.late': 'وصل متأخرًا في {received}',
  'msg.corr.withheld': 'غير معروض لأنك لا تملك صلاحية القراءة: {names}.',
  'msg.corr.source.jobs': 'المهام الخلفية',
  'msg.corr.source.credential_operations': 'عملية صلاحية دخول',
  'msg.corr.source.adapter_operations': 'عملية محوّل',
  'msg.corr.source.verifications': 'معاملات التحقق من الهوية',
  'msg.corr.source.webhooks': 'تسليمات Webhook',
  'msg.corr.source.access_events': 'حدث دخول',
  'msg.corr.source.camera_reads': 'قراءة كاميرا',
  'msg.corr.direction.entry': 'دخول',
  'msg.corr.direction.exit': 'خروج',
  'msg.corr.direction.unknown': 'الاتجاه غير معروف',
  // ------------------------------------------------------------ OR-11 reports (PD-536, PD-537)
  'msg.rpt.def.cards.assignments.title': 'سجل تسليم البطاقات',
  'msg.rpt.def.cards.assignments.description': 'البطاقات الفعلية المسلّمة أو المعادة أو المسجّلة مفقودة في الفترة حسب الموقع أو اليوم؛ ولا يظهر من حمل كل بطاقة إلا بصلاحية التفاصيل.',
  'msg.rpt.def.visits.late_arrivals.title': 'حالات الوصول المتأخر',
  'msg.rpt.def.visits.late_arrivals.description': 'حالات الوصول المرصودة مقارنةً بكل نافذة مخططة، ضمن فئات التأخر، حسب الموقع أو اليوم أو المضيف أو القسم أو نوع الزائر. لا تشمل الزيارات دون موعد.',
  'msg.rpt.note.cardCustody': 'تُسجَّل عهدة البطاقة منفصلة عن الحضور وعن صلاحيات الدخول: قد تُحتجز البطاقة المعادة حتى يُؤكَّد تعطيل كل صلاحيات حاملها.',
  'msg.rpt.note.cardPeriod': 'يُحتسب التسليم إذا كانت البطاقة خارج العهدة في أي وقت من الفترة؛ وحسب اليوم يُعدّ في يوم تسليمها (أو أول يوم في الفترة).',
  'msg.rpt.note.lateDefinition': 'التأخر = أول وصول مرصود للنافذة ناقص بداية النافذة. حتى 15 دقيقة بعد البداية يُعدّ في الموعد، والوصول قبل البداية في الموعد كذلك.',
  'msg.rpt.note.lateWalkIns': 'الزيارات دون موعد ليس لها بداية مخططة فلا تُحتسب. والنافذة دون وصول مرصود لا تُحتسب هنا؛ راجع تقرير عدم الحضور.',
  'msg.rpt.metric.assignments': 'عمليات التسليم',
  'msg.rpt.metric.returned': 'المعادة',
  'msg.rpt.metric.lost': 'المسجّلة مفقودة',
  'msg.rpt.metric.open': 'ما زالت خارج العهدة',
  'msg.rpt.metric.distinctCards': 'بطاقات مختلفة',
  'msg.rpt.metric.heldNow': 'محتجزة للسلامة الآن',
  'msg.rpt.def.assignments': 'عمليات تسليم البطاقات التي تتداخل عهدتها مع الفترة.',
  'msg.rpt.def.returned': 'منها، ما انتهى بإعادة مسجّلة.',
  'msg.rpt.def.lost': 'منها، ما انتهى بفقدان مسجّل.',
  'msg.rpt.def.open': 'منها، ما لم ينتهِ بعد: البطاقة ما زالت مع الزائر حسب علم الاستقبال.',
  'msg.rpt.def.heldNow': 'البطاقات في هذه المواقع المحتجزة حاليًا لأن صلاحية لآخر حامل لم يُؤكَّد تعطيلها بعد، الآن.',
  'msg.rpt.metric.measured': 'حالات وصول مقيسة',
  'msg.rpt.metric.onTime': 'في الموعد',
  'msg.rpt.metric.late': 'متأخر',
  'msg.rpt.metric.lateMedian': 'وسيط التأخر (دقيقة)',
  'msg.rpt.def.measured': 'النوافذ المخططة التي تبدأ في الفترة ولها وصول مرصود.',
  'msg.rpt.def.onTime': 'حالات الوصول المقيسة خلال 15 دقيقة من بداية النافذة أو قبلها.',
  'msg.rpt.def.late': 'حالات الوصول المقيسة بعد أكثر من 15 دقيقة من بداية النافذة.',
  'msg.rpt.def.lateMedian': 'وسيط الدقائق بعد بداية النافذة لحالات التأخر فقط؛ فارغ إن لم يتأخر أحد.',
  'msg.rpt.col.card': 'البطاقة',
  'msg.rpt.col.assignedAt': 'وقت التسليم',
  'msg.rpt.col.endedAt': 'وقت الإعادة / الفقدان',
  'msg.rpt.col.assignmentState': 'التسليم',
  'msg.rpt.col.custodyNow': 'عهدة البطاقة الآن',
  'msg.rpt.col.minutesLate': 'دقائق بعد البداية',
  'msg.rpt.col.band': 'التأخر',
  'msg.rpt.custody.available': 'متاحة',
  'msg.rpt.custody.assigned': 'مسلّمة',
  'msg.rpt.custody.returned_held': 'معادة ومحتجزة للسلامة',
  'msg.rpt.custody.lost': 'مفقودة',
  'msg.rpt.custody.disabled': 'معطّلة',
  'msg.rpt.custody.maintenance': 'صيانة',
  'rpt.ui.state.open': 'ما زالت خارج العهدة',
  'rpt.ui.state.returned': 'معادة',
  'rpt.ui.state.lost': 'مسجّلة مفقودة',
  'rpt.ui.state.on_time': 'في الموعد',
  'rpt.ui.state.late_15_30': 'متأخر 15–30 دقيقة',
  'rpt.ui.state.late_30_60': 'متأخر 30–60 دقيقة',
  'rpt.ui.state.late_60_plus': 'متأخر أكثر من 60 دقيقة',
  // ------------------------------------------------------------ PB-04-08 invitation required actions (PD-526)
  'msg.req.confirm_contact': 'أكّد بيانات الاتصال',
  'msg.req.accept': 'الموافقة على: {label}',
  'msg.req.sign': 'توقيع: {label}',
  'msg.req.upload': 'رفع: {label}',
  'msg.req.upload_again': 'ارفع مجددًا (لم يُقبل الملف السابق): {label}',
  'msg.req.replace': 'ارفع مستندًا صالحًا طوال زيارتك: {label}',
  'msg.req.beforeArrival': 'لا يمكن للاستقبال تسجيل وصولك إلا بعد إكمال هذه الخطوات.',
  // ------------------------------------------------------------ PB-09-14 delivery notices by SMS (PD-528 – PD-530)
  'msg.dlv.sms': 'Passage: لديك شحنة من {courier} في {site} ({count} طرد، المرجع {reference}). منطقة التسليم: {point}. يسجّل المكتب التسليم.',
  'vpolicy.ntf.t.delivery_notice': 'شحنة بانتظار المستلم',
  'dlv.reason.no_phone': 'لا يوجد رقم جوال للمستلم',
  'dlv.reason.channel_unavailable': 'لم يُضبط مزوّد للرسائل النصية',
  'dlv.reason.channel_disabled': 'لم تعد هذه القناة مفعّلة لإشعارات الشحنات',
  'msg.v.mobilePhone': 'أدخل رقم الجوال بالصيغة الدولية، مثل ‎+971501234567.',
  'msg.hosts.mobilePhone': 'رقم الجوال (اختياري)',
  'msg.hosts.mobilePhoneHint': 'يُستخدم فقط لإشعارات الموظفين النصية، مثل شحنة بانتظارك في المكتب. لا يظهر في دليل المضيفين.',
};
